export default {
  state: {
    counters: {},
    languages: [],
    packageTypes: [],
    packageCategories: []
  },
  mutations: {
    updateSearchCounters(state, payload) {
      state.counters = payload;
    },
    updateSearchProjectLanguages(state, payload) {
      state.languages = payload;
    },
    updateSearchPackageTypes(state, payload) {
      state.packageTypes = payload;
    },
    updateSearchPackageCategories(state, payload) {
      state.packageCategories = payload;
    }
  },
  actions: {
    updateSearchCounters(state, payload) {
      state.commit('updateSearchCounters', payload);
    },
    updateSearchProjectLanguages(state, payload) {
      state.commit('updateSearchProjectLanguages', payload);
    },
    updateSearchPackageTypes(state, payload) {
      state.commit('updateSearchPackageTypes', payload);
    },
    updateSearchPackageCategories(state, payload) {
      state.commit('updateSearchPackageCategories', payload);
    }
  },
  getters: {
    getSearchCounterByKey: (state) => (key) => state.counters[key] || null,
    getSearchProjectLanguages(state) {
      return state.languages;
    },
    getSearchPackageTypes(state) {
      return state.packageTypes;
    },
    getSearchPackageCategories(state) {
      return state.packageCategories;
    }
  }
};
